import VueRouter from 'vue-router'
import store from '@/store'
import axios from 'axios'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/login/Login.vue')
  },
  {
    path: '/index',
    name: 'Index',
    icon: 'el-icon-menu',
    component: () => import('@/views/common/Index.vue'),
    redirect: '/index/Main',
    children: [{
      path: 'Main',
      name: 'HomeList',
      icon: 'el-icon-menu',
      component: () => import('@/views/system/HomeList.vue')
    }]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
var tag = true// 设置全局变量
// 路由拦截
router.beforeEach(async (to, form, next) => {
  // 第一次登录时，全局变量为true执行，第二次刷新，再次执行
  if (tag) {
    tag = false
    if (to.name === '/') {
      next()
    } else {
      axios.get('/server/fourG/menu/findMenu').then(res => {
        const rr = listRoutes(res.data)
        store.commit('setMenuData', rr)
        addRoutes(res.data)
        next({ path: to.fullPath, replace: true })
      })
    }
  } else {
    console.log('to.fullPath---' + to.fullPath)
    next()
  }
})
// 添加路由的方法
export function addRoutes (res) {
  res.forEach((Router, index) => {
    router.addRoute({
      path: Router.path,
      name: Router.name,
      icon: Router.icon,
      component: () => import('@/views/' + Router.component + '.vue')
    })
    let childrens = Router.children
    if (childrens !== undefined) {
      for (let i = 0; i < childrens.length; i++) {
        if (childrens[i] !== undefined) {
          router.addRoute('Home', {
            path: childrens[i].path,
            name: childrens[i].name,
            icon: childrens[i].icon,
            component: () => import('@/views/' + childrens[i].component + '.vue')
          })
        }
      }
    }
  })
}

// 遍历路由的方法
export function listRoutes (res) {
  const ar = []
  res.forEach((Router, index) => {
    let obj = []
    Router.children.forEach((r, j) => {
      obj.push({ name: r.name, path: r.path, icon: r.icon })
    })
    ar.push({ name: Router.name, path: Router.path, icon: Router.icon, child: obj })
  })
  return ar
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js